/**
 * Keep checkout gate in sync after back/forward cache restores a stale page.
 */
document.addEventListener("pageshow", (event) => {
  if (!event.persisted) return;
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: { scrollToTop: false }
    })
  );
});

/**
 * Shopify-managed account menu labels can stay in English ("Orders", "Profile")
 * even when the storefront language is Japanese. We patch those labels in DOM.
 */
(() => {
  const LABEL_MAP = {
    Orders: "注文履歴",
    Profile: "プロフィール"
  };

  function patchTextNodesInRoot(root) {
    if (!root || !root.querySelectorAll) return;
    const elements = root.querySelectorAll("*");
    elements.forEach((el) => {
      if (el.tagName === "SCRIPT" || el.tagName === "STYLE") return;

      const ariaLabel = el.getAttribute && el.getAttribute("aria-label");
      if (ariaLabel && LABEL_MAP[ariaLabel]) {
        el.setAttribute("aria-label", LABEL_MAP[ariaLabel]);
      }

      const title = el.getAttribute && el.getAttribute("title");
      if (title && LABEL_MAP[title]) {
        el.setAttribute("title", LABEL_MAP[title]);
      }

      for (const node of el.childNodes) {
        if (node.nodeType !== Node.TEXT_NODE) continue;
        const trimmed = String(node.nodeValue || "").trim();
        if (!LABEL_MAP[trimmed]) continue;
        const leading = /^\s*/.exec(node.nodeValue || "")?.[0] || "";
        const trailing = /\s*$/.exec(node.nodeValue || "")?.[0] || "";
        node.nodeValue = `${leading}${LABEL_MAP[trimmed]}${trailing}`;
      }
    });
  }

  function patchOpenShadowRoots(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll("*").forEach((el) => {
      if (el.shadowRoot) {
        patchTextNodesInRoot(el.shadowRoot);
      }
    });
  }

  function patchCustomerAccountLabels() {
    const lang = document.documentElement.lang || "";
    if (!lang.startsWith("ja")) return;
    patchTextNodesInRoot(document);
    patchOpenShadowRoots(document);
  }

  function initCustomerAccountLabelPatch() {
    patchCustomerAccountLabels();
    const observer = new MutationObserver(() => patchCustomerAccountLabels());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCustomerAccountLabelPatch);
  } else {
    initCustomerAccountLabelPatch();
  }
})();
